(() => {
  const tabs = qsa('.js-tabular__tab');
  const contentItems = qsa('.js-tabular__item');
  const tabActiveClass = 'tabular__tab--active';
  const contentActiveClass = 'tabular__item--active';
  if(tabs) {
    tabs.forEach(item => {
      item.addEventListener('click', e => {
        e.preventDefault();
        const target = e.target.dataset.target;
        const contents = qsa(`[data-tab-content="${target}"]`);

        tabs.forEach(tab => {
          tab.classList.remove(tabActiveClass);
        });
        e.target.classList.add(tabActiveClass);
        
        contentItems.forEach(item => {
          item.classList.remove(contentActiveClass);
        });
        if(contents) {
          contents.forEach(item => {
            item.classList.add(contentActiveClass);
          })
        }
      })
    });
  }
})();